<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 transition-colors duration-300 font-sans">
    
    <div class="bg-white dark:bg-gray-800 p-10 rounded-lg shadow-lg w-full max-w-md text-center transition-colors duration-300 border border-transparent dark:border-gray-700">
      
      <img src="/media/icon.png" alt="Icono" class="mx-auto mb-6 h-20 w-auto object-contain" />
      
      <h1 class="text-2xl font-bold text-gray-800 dark:text-white mb-8">File Manager</h1>
      
      <form @submit.prevent="handleLogin" class="text-left">
        
        <div class="mb-6">
          <label for="username" class="block mb-2 font-medium text-gray-700 dark:text-gray-300">Usuario</label>
          <input 
            type="text" 
            id="username" 
            v-model="username" 
            required
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors"
          >
        </div>
        
        <div class="mb-6">
          <label for="password" class="block mb-2 font-medium text-gray-700 dark:text-gray-300">Contraseña</label>
          <input 
            type="password" 
            id="password" 
            v-model="password" 
            required
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors"
          >
        </div>
        
        <div class="mt-8">
          <button 
            type="submit" 
            :disabled="loading"
            class="w-full py-3 bg-blue-600 text-white rounded-md font-medium text-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors shadow-sm"
          >
            {{ loading ? 'Cargando...' : 'Iniciar Sesión' }}
          </button>
        </div>

        <div v-if="error" class="mt-4 p-3 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 rounded text-sm">
          {{ error }}
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const API_BASE_URL = process.env.VUE_APP_API_URL || '/api';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: null,
    };
  },
  mounted() {
    // --- LÓGICA DE DETECCIÓN DE MODO OSCURO ---
    // Aunque no haya botón, leemos la preferencia para mostrar el login acorde al resto de la app
    const savedTheme = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (savedTheme === 'dark' || (!savedTheme && systemPrefersDark)) {
        document.documentElement.classList.add('dark');
    } else {
        document.documentElement.classList.remove('dark');
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.post(`${API_BASE_URL}/token/`, {
          username: this.username,
          password: this.password,
        });

        sessionStorage.setItem('accessToken', response.data.access);
        sessionStorage.setItem('refreshToken', response.data.refresh);

        this.$router.push('/');

      } catch (err) {
        console.error(err);
        if (err.response) {
            this.error = 'Error: ' + (err.response.data.detail || 'Credenciales incorrectas');
        } else if (err.request) {
            this.error = 'El servidor no responde (502/Network Error).';
        } else {
            this.error = 'Error desconocido.';
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Ya no necesitamos CSS manual, todo es Tailwind */
</style>